var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('Navbar'),_c('Carousel'),_c('br'),_c('Snakelist')],1)}
var staticRenderFns = []

export { render, staticRenderFns }